// SPDX-License-Identifier: AGPL-3.0-or-later

import {PREMIUM_PRODUCT_NAME} from '@app/features/app/config/I18nDisplayConstants';
import GuildBoosts from '@app/features/boost/state/GuildBoosts';
import {BOOST_THIS_COMMUNITY_DESCRIPTOR} from '@app/features/boost/utils/GuildBoostMessages';
import {GET_PREMIUM_DESCRIPTOR} from '@app/features/i18n/utils/CommonMessageDescriptors';
import {shouldShowPremiumFeatures} from '@app/features/premium/utils/PremiumUtils';
import {Button} from '@app/features/ui/button/Button';
import Users from '@app/features/user/state/Users';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';

export const GuildBoostActionButton = observer(
	({acting, onBoost}: {acting: boolean; onBoost: () => Promise<unknown>}) => {
		const {i18n} = useLingui();
		const hasFreeSlot = GuildBoosts.hasFreeSlot;
		// A member who already has premium (lifetime included) gets no slot from buying it.
		if (!hasFreeSlot && (!shouldShowPremiumFeatures() || Users.currentUser?.isPremium())) return null;
		return (
			<Button small submitting={acting} onClick={onBoost} data-flx="boost.action.button">
				{hasFreeSlot
					? i18n._(BOOST_THIS_COMMUNITY_DESCRIPTOR)
					: i18n._(GET_PREMIUM_DESCRIPTOR, {premiumProductName: PREMIUM_PRODUCT_NAME})}
			</Button>
		);
	},
);
